import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/share';
import { UrlManagerService } from './url-manager.service';
import { LoginService } from './login.service';
import { GetService } from './get.service';
import { Router } from '@angular/router';

@Injectable()
export class PostService {

  constructor(private http: Http, private UrlManager: UrlManagerService, private loginService: LoginService, private getService: GetService, private router: Router) {

  }

  postBooks(bookInventory) {
    return this.http.post(this.UrlManager.getApiUrl() + "/inventory/books", bookInventory, this.UrlManager.getOptions()).subscribe((response) => {

    });
  }



}



// WEBPACK FOOTER //
// ./src/app/Services/post.service.ts